import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {UiVorgang} from '../../../models/uiVorgang';
import {UiContainerSpalte} from '../../../models/uiContainerSpalte';
import {EventService} from '../../../services/event.service';
import {tap, filter, Subscription} from 'rxjs';
import {flatMap, UiBaseControl, UIContainerControl} from '../../../models/uiArtefakt';
import {map} from 'rxjs/operators';

@Component({
    selector: 'lv-sticky-header',
    templateUrl: './sticky-header.component.html',
    styleUrls: ['./sticky-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('showNavigationAnimation', [
            state('void', style({ transform: 'translateX(-100%)' })),
            transition(':enter', [
                animate('.5s ease', style({ transform: 'translateX(0)' })),
            ]),
        ])
    ],
    standalone: false
})
export class StickyHeaderComponent implements OnInit, OnDestroy {
  @Input()
  public uiVorgang: UiVorgang;

  @Input()
  public uiSpalte: UiContainerSpalte;

  public uiVorgangLayoutSpalte = UiContainerSpalte;
  public showNavigation: boolean;
  public showBeitrag: boolean;
  public shrinkedLabel: string = '';

  private _uiControlsSubscription = Subscription.EMPTY;

  constructor(private _eventService: EventService) {
  }

  ngOnInit(): void {
    this._uiControlsSubscription = this._eventService.uiControls$.pipe(
        map(uiControl => flatMap(uiControl.uiVorgang.UIArtefakt).filter(
            artefakt => (artefakt as UIContainerControl).UIContainerComponent === 'SpalteRechts')[0]),
        filter(artefakt => !!artefakt),
        tap(artefakt => this.shrinkedLabel = (artefakt as UIContainerControl).ShrinkedLabel)).subscribe();
  }

  ngOnDestroy(): void {
    if (this._uiControlsSubscription) {
      this._uiControlsSubscription.unsubscribe();
    }
  }
}
